export function eventsSlider() {
    const $window = $(window);
    const $slider = $(".events-slider");
    let sliderNav = "";
    let $current = "";
    let $total = "";


    $slider.each(function () {
        let $this = $(this);
        sliderNav = $this.next(".events-slider-nav");
        $current = sliderNav.find('.current');
        $total = sliderNav.find('.total');
        $this.slick({
            dots: false,
            arrows: true,
            appendArrows: sliderNav,
            infinite: false,
            speed: 700,
            fade: true,
            cssEase: 'ease',
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        fade: false,
                    }
                },

            ]
        }).on('init reInit afterChange', function (event, slick, currentSlide) {
            let i = (currentSlide ? currentSlide : 0) + 1;
            $current.text(i);
            $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
        });
        $total.text($this.find(".slick-slide:not(.slick-active)").length + 1);
        $current.text("1");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/eventsSlider.js